module.exports = __webpack_public_path__ + "img/iot4.65cc43f0.png";